import React, { useEffect, useState } from "react";
import logo from "../assets/trimo-logo.png";

const CSS = `
@keyframes vtLogo{0%{transform:scale(.6) translateY(10px);opacity:0;filter:blur(8px)}60%{transform:scale(1.04);opacity:1;filter:blur(0)}100%{transform:scale(1)}}
@keyframes vtGlow{0%,100%{opacity:.35;transform:scale(.9)}50%{opacity:.7;transform:scale(1.1)}}
@keyframes vtShine{0%{transform:translateX(-160%) skewX(-20deg)}100%{transform:translateX(260%) skewX(-20deg)}}
@keyframes vtLetter{0%{opacity:0;transform:translateY(14px);filter:blur(4px)}100%{opacity:1;transform:none;filter:none}}
@keyframes vtFade{0%{opacity:0;transform:translateY(6px)}100%{opacity:1;transform:none}}
@keyframes vtBar{0%{width:0}35%{width:38%}70%{width:76%}100%{width:100%}}
@keyframes vtClip{0%,100%{opacity:.25}50%{opacity:1}}
@keyframes vtCut{0%{left:-2%}100%{left:102%}}
`;

const Timeline = () => (
  <div style={{ position: "relative", width: 260, height: 26, marginTop: 34, animation: "vtFade .5s ease .9s both" }}>
    <div style={{ display: "flex", gap: 4, height: "100%" }}>
      {[18, 30, 14, 24, 36, 20, 28].map((w, i) => (
        <span key={i} style={{ flex: w, borderRadius: 4, background: i % 3 === 1 ? "#facc15" : "rgba(255,255,255,.12)", animation: `vtClip 1.6s ease-in-out ${i * 0.12}s infinite` }} />
      ))}
    </div>
    <span style={{ position: "absolute", top: -6, bottom: -6, width: 2, borderRadius: 2, background: "#fff", boxShadow: "0 0 12px #facc15", animation: "vtCut 1.8s cubic-bezier(.6,0,.4,1) infinite" }} />
  </div>
);

export default function Splash({ onDone }) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setLeaving(true), 2700);
    const t2 = setTimeout(() => onDone && onDone(), 3250);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div data-testid="splash-screen" style={{
      position: "fixed", inset: 0, zIndex: 9999, background: "#09090A", overflow: "hidden",
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      opacity: leaving ? 0 : 1, transform: leaving ? "scale(1.03)" : "none",
      transition: "opacity .5s ease, transform .5s ease", pointerEvents: leaving ? "none" : "auto",
    }}>
      <style>{CSS}</style>
      <div style={{ position: "absolute", inset: 0, opacity: 0.5, backgroundImage: "radial-gradient(rgba(255,255,255,.06) 1px, transparent 1px)", backgroundSize: "22px 22px", maskImage: "radial-gradient(circle at 50% 45%, #000 0%, transparent 65%)", WebkitMaskImage: "radial-gradient(circle at 50% 45%, #000 0%, transparent 65%)" }} />
      <div style={{ position: "absolute", width: 420, height: 420, borderRadius: "50%", background: "rgba(250,204,21,.14)", filter: "blur(90px)", animation: "vtGlow 3s ease-in-out infinite" }} />

      <div style={{ position: "relative", width: 96, height: 96, borderRadius: 24, overflow: "hidden", boxShadow: "0 20px 60px -10px rgba(250,204,21,.45)", animation: "vtLogo .8s cubic-bezier(.2,.8,.2,1) both" }}>
        <img src={logo} alt="Vitled" style={{ width: "100%", height: "100%", display: "block" }} />
        <span style={{ position: "absolute", top: 0, bottom: 0, width: "45%", background: "linear-gradient(90deg,transparent,rgba(255,255,255,.55),transparent)", animation: "vtShine 1.1s ease .7s both" }} />
      </div>

      <div style={{ marginTop: 22, display: "flex", fontWeight: 900, fontSize: 40, letterSpacing: "-.03em", fontFamily: "'Montserrat', 'Inter', sans-serif" }} data-testid="splash-wordmark">
        {"Vitled".split("").map((ch, i) => (
          <span key={i} style={{ color: i >= 3 ? "#facc15" : "#fff", display: "inline-block", animation: `vtLetter .5s cubic-bezier(.2,.8,.2,1) ${0.35 + i * 0.06}s both` }}>{ch}</span>
        ))}
      </div>
      <p style={{ marginTop: 6, fontSize: 12, letterSpacing: ".32em", textTransform: "uppercase", color: "#71717a", fontWeight: 600, animation: "vtFade .5s ease .8s both" }}>AI Viral Clips</p>

      <Timeline />

      <div style={{ position: "absolute", bottom: 48, width: 180, animation: "vtFade .4s ease .5s both" }}>
        <div style={{ height: 2, borderRadius: 2, background: "rgba(255,255,255,.08)", overflow: "hidden" }}>
          <div style={{ height: "100%", background: "linear-gradient(90deg,#f59e0b,#facc15)", animation: "vtBar 2.5s cubic-bezier(.4,0,.2,1) both" }} />
        </div>
        <p style={{ marginTop: 10, textAlign: "center", fontSize: 10, letterSpacing: ".2em", color: "#52525b", textTransform: "uppercase" }}>{(localStorage.getItem("trimo_lang") || navigator.language || "es").startsWith("es") ? "Preparando tu estudio" : "Preparing your studio"}</p>
      </div>
    </div>
  );
}
